import { Alert, Table } from 'antd';
import './TableData.css';

const TableData = ({ data, openTable }: any) => {
	
	const limitedData: any = data?.slice(0, 100);

	const columns = Object?.keys(data[0])?.map((key: any) => ({
		title: key?.replace(/([A-Z])/g, ' $1')?.toUpperCase(),
		dataIndex: key,
		key: key
	}));

	const pagination:any = limitedData?.length > 10 ? { size: 'small' } : false;


	return (
		<div>
		
			<Table
				className="custom-tablepurchase1"
				dataSource={limitedData}
				columns={columns}
				rowKey={(record: any) => record?.purchaseInvoiceNumber}
				pagination={pagination}
			/>
		</div>
	);
};

export default TableData;
